import { ADD_STANDINGS } from "../constants/standingsConstants";

const standingsReducer = (state = [], action) => {
  switch (action.type) {
    case ADD_STANDINGS:
      if (Array.isArray(action.payload)) {
        return [...state, ...action.payload];
      } else {
        return [...state, action.payload];
      }
    default:
      return state;
  }
};

export default standingsReducer;
